import {Step} from '../../../../../../shared/types/form.types';

export const hasNewWorkStageItems = (steps: Step[], savedSteps: Step[]) =>
  steps.some((step) => {
    const savedStep = savedSteps.find((item) => item.id === step.id);
    return !savedStep || step.fieldGroups.some((group) => !savedStep.fieldGroups.some((item) => item.id === group.id));
  });
